export default "__VITE_ASSET__BK6obSd5__"